import Moment from 'moment'

const ics = require('ics-browser')

export const createGoogleCalendarURL = payload => {
  const { name } = payload
  const startTime = new Moment()
    .utc()
    .add(1, 'hours')
    .format('YYYYMMDDTHHmmss')
  const endTime = new Moment(startTime).add(0.5, 'hours').format('YYYYMMDDTHHmmss')

  let url = 'https://www.google.com/calendar/render?action=TEMPLATE'
  if (name) {
    url += `&text=${name}`
  }
  if (startTime && endTime) {
    url += `&dates=${startTime}Z/${endTime}Z`
  }
  return url
}

export const createICalendarEvent = payload => {
  const { name, datetime, duration } = payload
  const startTime = new Moment(datetime).utc().add(1, 'hours')
  const year = startTime.year()
  // months are zero indexed
  const month = startTime.month() + 1
  const date = startTime.date()
  const hour = startTime.hour()
  const minute = startTime.minute()
  const hours = duration * 1

  const event = {
    start: [year, month, date, hour, minute],
    duration: { hours },
    title: name,
  }
  ics.createEvent(event, (err, value) => {
    const filename = `${name}.ics`
    const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}



// WEBPACK FOOTER //
// ./src/utils/addToCalendar.js